import { storeLinks } from '~/utils/app-config';
import { extractSearchParams, shouldRedirectToStore } from '~/utils/store-redirect';

export default function ({ app, route }) {
  // Check if we're on mobile
  const userAgent = navigator.userAgent || navigator.vendor || '';
  const isAndroid = /Android/i.test(userAgent);
  const isIOS = /iPad|iPhone|iPod/i.test(userAgent);

  // If not on mobile, do nothing
  if (!isAndroid && !isIOS) return;

  // Get full path with query params
  const fullPath = window.location.href;

  // Get path without language prefix
  const path = route.path;
  const locales = app.i18n.locales.map(locale => locale.code);
  const localeRegex = new RegExp(`^/(${locales.join('|')})/`);
  const pathWithoutLocale = path.replace(localeRegex, '/');

  // Extract query parameters
  const searchParams = extractSearchParams(fullPath);

  // Check if we should redirect
  if (shouldRedirectToStore(pathWithoutLocale, searchParams)) {
    const storeLink = isIOS ? storeLinks.apple : isAndroid ? storeLinks.google : null;
    if (storeLink) {
      window.location.href = storeLink;
    }
  }
}
